import Dictionary from "~/ts/library/Dictionary";
import StringHelper from "~/ts/library/StringHelper";
import {__} from "~/ts/library/Translate";

export const SHORTCUT_NEXT_CHAT = "nextChat";
export const SHORTCUT_PREV_CHAT = "prevChat";
export const SHORTCUT_NEXT_UNREADED_CHAT = "nextUnreadedChat";
export const SHORTCUT_PREV_UNREADED_CHAT = "prevUnreadedChat";
export const SHORTCUT_NEXT_OPENED_CHAT = "nextOpenedChat";
export const SHORTCUT_PREV_OPENED_CHAT = "prevOpenedChat";
export const SHORTCUT_FOCUS_ON_TEXTAREA = "focusOnTextarea";
export const SHORTCUT_RITHORIC_QUESTION = "rithoricQuestion";
export const SHORTCUT_CLOSE_DIALOG = "closeDialog";
export const REMOVE_FROM_BUDDY_LIST = "removeFromBuddyList";
export const SHORTCUT_OPEN_TEMPLATES_DIALOG = "openTemplatesDialog";

export const SHORTCUT_INSERT_MESSAGE_TEMPLATE = "insertMessageTemplate";
export const SHORTCUT_START_BOT = "startBot";
export const SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO = "openLinkFromClientInfo";
export const SHORTCUT_SEND_TAB = "sendTab";

export const SHORTCUT_TOGGLE_COBROWSE = "toggleCobrowse";

export class ShortcutsList {
    public static get list(): Dictionary<{ defaultShortcut: string, descr: string }> {
        return {
            [SHORTCUT_NEXT_CHAT]: {
                defaultShortcut: "Alt+Down",
                descr: StringHelper.capitalize(__("следующий чат"))
            },
            [SHORTCUT_PREV_CHAT]: {
                defaultShortcut: "Alt+Up",
                descr: StringHelper.capitalize(__("предыдущий чат"))
            },
            [SHORTCUT_NEXT_UNREADED_CHAT]: {
                defaultShortcut: "Alt+Shift+Down",
                descr: StringHelper.capitalize(__("следующий непрочитанный чат"))
            },
            [SHORTCUT_PREV_UNREADED_CHAT]: {
                defaultShortcut: "Alt+Shift+Up",
                descr: StringHelper.capitalize(__("предыдущий непрочитанный чат"))
            },
            [SHORTCUT_NEXT_OPENED_CHAT]: {
                defaultShortcut: "Alt+Right",
                descr: __("Следующий открытый чат")
            },
            [SHORTCUT_PREV_OPENED_CHAT]: {
                defaultShortcut: "Alt+Left",
                descr: __("Предыдущий открытый чат")
            },
            [SHORTCUT_FOCUS_ON_TEXTAREA]: {
                defaultShortcut: "Escape",
                descr: __("Переключиться на поле ввода сообщения")
            },
            [SHORTCUT_RITHORIC_QUESTION]: {
                defaultShortcut: "Ctrl+Shift+Z",
                descr: __("Обращение не требует ответа")
            },
            [SHORTCUT_CLOSE_DIALOG]: {
                defaultShortcut: "Ctrl+Shift+F",
                descr: __("Завершить диалог")
            },
            [SHORTCUT_OPEN_TEMPLATES_DIALOG]: {
                defaultShortcut: "Ctrl+Shift+T",
                descr: __("Открыть диалоговое окно шаблонов сообщений")
            },
            [REMOVE_FROM_BUDDY_LIST]: {
                defaultShortcut: "Ctrl+Shift+X",
                descr: __("Убрать клиента из списка ваших чатов")
            },
            [SHORTCUT_TOGGLE_COBROWSE]: {
                defaultShortcut: "Ctrl+Shift+C",
                descr: "Co-Browse"
            }
        }
    }
}